import get_curly_brace_content from "./get_curly_brace_content"

export default (product_description_html, get_message) => {
  if (get_message) return get_curly_brace_content(product_description_html) ?
      get_curly_brace_content(product_description_html)[1] : ""
  else return product_description_html.match(/\[(.*)\]/) ?
      product_description_html.match(/\[(.*)\]/)[1].replace(/\s+/g, "").split(",") : []
}
